import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import Header from "./header"
import "./layout.css"
import Container from "./container"

const Layout = ({ lang = "en", children }) => {
  return (
    <>
      <Header
        lang={lang}
        siteTitle={lang === "ko" ? "비주얼 타이머" : "Visual Timer"}
      />
      <main>{children}</main>
      <Container>
        <footer
          style={{
            display: "flex",
            marginTop: `2rem`,
            marginBottom: `3rem`,
            fontSize: 14,
            color: "#666666",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div>
            <Link to={"/privacy-policy/"}>Privay Policy</Link>
          </div>
          <div>
            © {new Date().getFullYear()}
            {` `}
            <a href="https://www.edykim.com">edykim</a>
          </div>
        </footer>
      </Container>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
